module.exports = __webpack_public_path__ + "media/icons/warning-yellow-f6d1640c.svg";